import PropTypes from 'prop-types';

import { MONTHS } from 'utils/dateUtils';

/**
 * Fallback terms and conditions when API responses do not return nanobarTerms.
 */
function FallbackTermsAndConditions({ claimBy, disc }) {
    const claimByDate = new Date(claimBy?.date);
    const code = disc?.code;

    const formattedClaimByDate = `${
        MONTHS[claimByDate.getMonth()]
    } ${claimByDate.getDate()}, ${claimByDate.getFullYear()}`;

    return (
        <>
            Offer valid for orders placed by new customers before {formattedClaimByDate} at 11:59 p.m. ET with code{' '}
            {code}. Offer not valid for past purchases and may not be combined with other offers. Offer subject to
            applicable order minimum. Exclusions may apply.
        </>
    );
}

FallbackTermsAndConditions.propTypes = {
    claimBy: PropTypes.shape({
        date: PropTypes.string.isRequired,
    }).isRequired,
    disc: PropTypes.shape({
        code: PropTypes.string.isRequired,
    }).isRequired,
};

export { FallbackTermsAndConditions };
